(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opo-editorial-guide"] && !Shopify.designMode) return;
  try {
    
  function prepareOpoGuides(scope) {
    for (const guide of scope.querySelectorAll('[data-opo-guide]')) {
      if (guide.dataset.opoReady) continue;
      guide.dataset.opoReady = 'true';
      const content = guide.querySelector('.opo-guide-content');
      const headings = [...content.querySelectorAll('h2')];
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'opo-apartado-' + (index + 1);
      });
      if (!content.querySelector('nav') && headings.length > 2) {
        const nav = document.createElement('nav');
        nav.setAttribute('aria-label', guide.dataset.contentsLabel);
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = guide.dataset.contentsLabel;
        const list = document.createElement('ol');
        for (const heading of headings) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        }
        details.append(summary, list);
        nav.append(details);
        headings[0].before(nav);
      }
      const offer = guide.querySelector('[data-opo-inline]');
      if (offer && headings.length >= 5) {
        headings[2].before(offer);
        offer.hidden = false;
      }
      for (const table of content.querySelectorAll('table')) {
        let wrapper = table.parentElement;
        if (wrapper === content || wrapper.children.length !== 1) {
          wrapper = document.createElement('div');
          table.before(wrapper);
          wrapper.append(table);
        }
        wrapper.style.overflowX = 'auto';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent || guide.dataset.tableLabel);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareOpoGuides(document), { once: true });
  } else {
    prepareOpoGuides(document);
  }
  document.addEventListener('shopify:section:load', event => prepareOpoGuides(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opo-guide"] && !Shopify.designMode) return;
  try {
    
  function prepareOpoGuides(scope) {
    for (const guide of scope.querySelectorAll('[data-opo-guide]')) {
      if (guide.dataset.opoReady) continue;
      guide.dataset.opoReady = 'true';
      const content = guide.querySelector('.opo-guide-content');
      const headings = [...content.querySelectorAll('h2')];
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'opo-apartado-' + (index + 1);
      });
      if (!content.querySelector('nav') && headings.length > 2) {
        const nav = document.createElement('nav');
        nav.setAttribute('aria-label', guide.dataset.contentsLabel);
        const details = document.createElement('details');
        const summary = document.createElement('summary');
        summary.textContent = guide.dataset.contentsLabel;
        const list = document.createElement('ol');
        for (const heading of headings) {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.href = '#' + heading.id;
          link.textContent = heading.textContent;
          item.append(link);
          list.append(item);
        }
        details.append(summary, list);
        nav.append(details);
        headings[0].before(nav);
      }
      const offer = guide.querySelector('[data-opo-inline]');
      if (offer && headings.length >= 5) {
        headings[2].before(offer);
        offer.hidden = false;
      }
      for (const table of content.querySelectorAll('table')) {
        let wrapper = table.parentElement;
        if (wrapper === content || wrapper.children.length !== 1) {
          wrapper = document.createElement('div');
          table.before(wrapper);
          wrapper.append(table);
        }
        wrapper.style.overflowX = 'auto';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', table.caption?.textContent || guide.dataset.tableLabel);
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => prepareOpoGuides(document), { once: true });
  } else {
    prepareOpoGuides(document);
  }
  document.addEventListener('shopify:section:load', event => prepareOpoGuides(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["opotemario-catalog-filter"] && !Shopify.designMode) return;
  try {
    
function initOpoCatalog(root=document){
 root.querySelectorAll('[data-opo-catalog-filter]').forEach(form=>{
  if(form.dataset.ready)return;
  form.dataset.ready='true';
  const stage=form.elements.stage,specialty=form.elements.specialty;
  const pool=Array.from(specialty.options).map(option=>option.cloneNode(true));
  function reconcile(){
   const selected=specialty.value;
   const allowed=pool.filter(option=>!option.value||!stage.value||option.dataset.stage===stage.value);
   specialty.replaceChildren(...allowed.map(option=>option.cloneNode(true)));
   specialty.value=allowed.some(option=>option.value===selected)?selected:'';
  }
  stage.addEventListener('change',reconcile);
  specialty.addEventListener('change',()=>{
   if(specialty.value&&!stage.value){stage.value=specialty.selectedOptions[0].dataset.stage;reconcile();}
  });
  reconcile();
  form.addEventListener('submit',event=>{
   event.preventDefault();
   reconcile();
   const tags=['region','stage','specialty'].map(name=>form.elements[name].value).filter(Boolean);
   const url=new URL(form.dataset.baseUrl,window.location.origin);
   if(tags.length)url.pathname+='/'+Array.from(new Set(tags)).map(encodeURIComponent).join('+');
   if(form.elements.sort_by.value)url.searchParams.set('sort_by',form.elements.sort_by.value);
   window.location.assign(url.href);
  });
 });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>initOpoCatalog());else initOpoCatalog();
document.addEventListener('shopify:section:load',event=>initOpoCatalog(event.target));

  } catch(e) { console.error(e); }
})();
})();
